import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as AddPlusIcon } from '../../../assets/icons/add-plus.svg';
import s from './FacilityButton.module.scss';

/**
 * Add another facility button
 * @param {Object} props props with click handler
 * @returns {Object} component jsx
 */
const AddFacilityButton = forwardRef((props, ref) => {
  const { onClick } = props;

  return (
    <button type="button" onClick={onClick} className={s.wrapper} ref={ref}>
      <AddPlusIcon role="presentation" focusable="false" />
      <FormattedMessage id="offerWizard.addAnotherFacility" />
    </button>
  );
});

AddFacilityButton.propTypes = {
  /** click handler function */
  onClick: PropTypes.func.isRequired,
};

export default AddFacilityButton;
